(() => {
  if (window.__productInquiryInitialized) return;
  window.__productInquiryInitialized = true;
  const params = new URLSearchParams(window.location.search);
  const product = params.get('product');
  if (!product) return;
  document.querySelectorAll('[data-product-inquiry]').forEach(form => {
    const field = form.querySelector('textarea[name="contact[body]"]');
    if (!field || field.value.trim()) return;
    const path = params.get('product_path') || '';
    const validPath = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+$/i.test(path);
    field.value = `${form.dataset.inquiryIntro} ${product.slice(0, 250)}\n${validPath ? window.location.origin + path + '\n' : ''}\n${form.dataset.inquiryVehicle}\n${form.dataset.inquirySize}\n${form.dataset.inquiryQuestion}\n`;
  });
})();

